@if (!viewModel.totalQtyDisplay() && isBrowser) {
  <button class="center-container absolute-position" appFocusRemove
          (click)="goCart(menuTrigger)">
    <app-image-loading src="assets/icon_home_cart.svg" alt="購物車" i18n-alt
                       [clickable]="true"
                       [middle]="true"
                       [targetWidth]="21"
                       [targetHeight]="19"/>
    <span class="num">{{viewModel.totalQtyDisplay()}}</span>
  </button>
}
<button class="center-container" #menuTrigger="matMenuTrigger" appFocusRemove
        [matMenuTriggerFor]="cartMenu"
        [matMenuTriggerRestoreFocus]="false"
        [disabled]="!viewModel.totalQtyDisplay()"
        [class.none-display]="!viewModel.totalQtyDisplay()"
        (click)="goCart()"
        (mouseover)="openMenu($event, menuTrigger)"
        (mouseleave)="closeMenu($event, menuTrigger)"
        (focus)="clearTimeout()">
  <app-image-loading src="assets/icon_home_cart.svg" alt="購物車" i18n-alt
                     [clickable]="true"
                     [middle]="true"
                     [targetWidth]="21"
                     [targetHeight]="19"/>
  <span class="num">{{viewModel.totalQtyDisplay()}}</span>
</button>

<mat-menu #cartMenu class="stepper-panel outfit-cart-panel" yPosition="below" xPosition="before" overlapTrigger="false"
          [hasBackdrop]="false">
  <div class="notify-container" *ngIf="notificationItem() as item; else content">
    <div class="title-text" i18n>本商品已加入購物車</div>
    <div class="product-container notify row-container">
      <div class="product-img">
        <app-image-loading [targetWidth]="50"
                           [targetHeight]="50"
                           [clickable]="false"
                           [alt]="item.meta?.name ?? ''"
                           [src]="item.image"/>
      </div>
      <div class="info-container column-container">
        <div class="name text-ellipsis">{{item.meta?.name}}</div>
        <div class="row-container space-between">
          <div class="text-ellipsis">{{item | colorSize}}</div>
          <div>{{item.quantity | number}}</div>
        </div>
      </div>
    </div>
    <button class="buy-button notify common-button" appFocusRemove
            (click)="goCart()">
      <span i18n>前往結帳</span>
    </button>
  </div>
  <ng-template #content>
    <div class="menu-container"
         (mouseover)="clearTimeout()"
         (mouseleave)="closeMenu($event, menuTrigger)"
         (focus)="clearTimeout()">
      <div class="menu-content desktop">
        @for (item of viewModel.cart().items; track item.skuId) {
          <div class="product-container row-container">
            <a [routerLink]="item.skuId | productLink" class="product-img">
              <app-image-loading [targetWidth]="50"
                                 [targetHeight]="50"
                                 [clickable]="false"
                                 [alt]="item.meta?.name ?? ''"
                                 [src]="item.image"/>
            </a>
            <div class="info-container column-container">
              <a [routerLink]="item.skuId | productLink" class="name text-ellipsis">{{item.meta?.name}}</a>
              <div class="row-container space-between">
                <a [routerLink]="item.skuId | productLink" class="full-width text-ellipsis">{{item | colorSize}}</a>
                <div class="row-container">
                  <div>{{item.quantity | number}}</div>
                  <button class="remove-btn" appFocusRemove
                          (click)="viewModel.deleteCartItem(item, $event)">
                    <app-image-loading class="icon-margin" src="assets/icon_delete.svg" alt="刪除" i18n-alt
                                       [clickable]="true"
                                       [middle]="true"
                                       [targetWidth]="13"
                                       [targetHeight]="13"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      @if (viewModel.totalQtyDisplay()) {
        <button class="buy-button common-button" appFocusRemove
                (click)="goCart()">
          <span i18n>前往結帳</span>
        </button>
      }
    </div>
  </ng-template>
</mat-menu>
